<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>El nacimiento de una Nación Independiente.</h2>
    <img @click="imageClicked(0)" src="galerias/gameRoom/acta_independencia.jpg" class="mainphoto"/>
    <p class="photo-description">Reproducción del Acta de Independencia del Imperio Mexicano. Redactada por la Suprema Junta Provisional Gubernativa, tinta sobre papel, 1821. Col. Museo Nacional de Historia.</p>
    <p>El Acta de Independencia del Imperio Mexicano fue redactada en el Palacio Nacional de la Ciudad de México, el 28 de septiembre de 1821.</p>
    <p>Existieron dos ejemplares originales del acta. Una permaneció en la Cámara de Diputados, pero fue destruida en el incendio de 1909. La otra copia, fue robada y vendida en 1830. Fue recuperada por Maximiliano de Habsburgo y tras su fusilamiento, fue sacada del país.</p>
    <p>Después de ser vendida en varias ocasiones, llegó a manos de Florencio Gavito, quien estipuló en su testamento que al morir se entregara el Acta al Gobierno de la República, estando como presidente Adolfo López Mateos.</p>
    <p>La primera firma de este documento fundamental para la historia de México es de Agustín de Iturbide, y la segunda es la del obispo de Puebla, Antonio Joaquín Pérez Martínez,</p>
    <p>Conoce más:
      <ul>
        <li><a target="_blank" href="https://memoricamexico.gob.mx/swb/memorica/Cedula?oId=8RATcnIB-uS572yO8W29">memoricamexico.gob.mx</a></li>
        <li><a target="_blank" href="https://mediateca.inah.gob.mx/islandora_74/islandora/object/objetohistorico%3A2301">mediateca.inah.gob.mx</a></li>
      </ul>
    </p>
    <h4>Plan de Iguala.</h4>
    <p>La historia de Tlaxcala y su contribución a lo Mexicano. Autor: Desiderio Hernández Xochitiotzin, pintura mural, 1968. Col. Gobierno del estado de Tlaxcala</p>
    <p>Conoce más:
      <ul>
        <li><a target="_blank" href="https://www.gob.mx/sedena/documentos/24-de-febrero-de-1821-proclamacion-del-plan-de-iguala-233730">www.gob.mx</a></li>
      </ul>
    </p>
  </div>
</template>

<script>
export default {
  name: "GameM5",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
};
</script>
